import { BridgeComponent } from '@hotwired/hotwire-native-bridge'
import { Turbo } from '@hotwired/turbo-rails'

// Déclenche le login OAuth natif (Apple / Google / Facebook) depuis le hub
// d'authentification de l'app iOS. Le flux ne pouvant pas se dérouler dans la
// WKWebView, le clic est délégué au SDK natif via OauthComponent.
//
// Aller-retour : clic → send('start', { provider }) → le natif rend
// reply { url } (magic login à charger, qui pose la session Rails) ou
// reply { error }.
//
// Sans adapter natif (`enabled` faux) le controller ne fait rien : l'écran n'est
// de toute façon rendu que pour l'app (Users::AuthHubController).
export default class extends BridgeComponent {
  static component = 'oauth'
  static targets = ['button', 'error']
  static values = { messages: Object }

  // Filet de sécurité : sans réponse du natif (composant absent, SDK planté), les
  // boutons resteraient désactivés jusqu'au rechargement. Large, parce que
  // l'aller-retour inclut l'interaction utilisateur (Face ID, consentement…).
  static REPLY_TIMEOUT = 120000

  disconnect() {
    this.#clearTimeout()
  }

  start(event) {
    if (!this.enabled || this.busy) return

    event.preventDefault()
    this.#setBusy(true)
    this.#hideError()

    // Aucun message à l'expiration : on ne sait pas que ça a échoué, on rend
    // seulement la main pour permettre un nouvel essai.
    this.timeoutId = setTimeout(() => this.#setBusy(false), this.constructor.REPLY_TIMEOUT)

    this.send('start', { provider: event.currentTarget.dataset.oauthProvider }, ({ data }) =>
      this.#handleReply(data || {})
    )
  }

  #handleReply({ url, error }) {
    this.#clearTimeout()

    if (url) {
      this.#signIn(url)
      return
    }

    this.#setBusy(false)

    // L'annulation est délibérée, pas un incident : rien à afficher.
    if (error && error !== 'cancelled') this.#showError(error)
  }

  // Chargé comme une page, le magic login rendait sa redirection dans l'écran de connexion
  // avant la bascule sur les onglets : seule la page d'arrivée est proposée à l'app.
  async #signIn(url) {
    try {
      const response = await fetch(url, { credentials: 'same-origin' })
      Turbo.visit(response.url)
    } catch {
      window.location.assign(url)
    }
  }

  #setBusy(busy) {
    this.busy = busy
    this.buttonTargets.forEach((button) => {
      button.disabled = busy
      button.classList.toggle('opacity-60', busy)
    })
  }

  #showError(error) {
    if (!this.hasErrorTarget) return
    this.errorTarget.textContent = this.messagesValue[error] || this.messagesValue.failed
    this.errorTarget.hidden = false
  }

  #hideError() {
    if (this.hasErrorTarget) this.errorTarget.hidden = true
  }

  #clearTimeout() {
    clearTimeout(this.timeoutId)
    this.timeoutId = null
  }
}
